import { keepPreviousData } from "@tanstack/react-query";
import { isVirtualFolder } from "@zapier/utils";
import { RouterInputs, RouterOutputs, trpc } from "../trpc";

export type ListAssetSharesInput = RouterInputs["permission"]["listShares"];
export type AssetShare = RouterOutputs["permission"]["listShares"][number];

interface Options {
  enabled?: boolean;
}

export function useQueryAssetShares(
  input: ListAssetSharesInput,
  options?: Options,
) {
  const isRequestForVirtualFolder =
    input.assetType === "folder" && isVirtualFolder(input.assetId);

  const { data, isLoading, isFetching } = trpc.permission.listShares.useQuery(
    input,
    {
      placeholderData: keepPreviousData,
      enabled: options?.enabled !== false && !isRequestForVirtualFolder,
      trpc: {
        context: {
          skipBatching: true,
        },
      },
    },
  );

  return {
    shares: data || [],
    isLoading,
    isFetching,
  };
}
